// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MevR","buttons":"styles_buttons__28Pbt"};